var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg"},[_c('v-select',{attrs:{"id":"event","items":_vm.events,"label":_vm.getI18n('event'),"disabled":_vm.params.event.disabled},model:{value:(_vm.event_id),callback:function ($$v) {_vm.event_id=$$v},expression:"event_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }